// extracted by mini-css-extract-plugin
module.exports = {"decisionsToolbar":"DecisionsWidget_decisionsToolbar__1qIr3"};